document.addEventListener("DOMContentLoaded", function() {
  const counters = document.querySelectorAll('.climbing-number');
  const duration = 1500;

  const animateCounters = (entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const counter = entry.target;
        const target = +counter.getAttribute('data-target');
        const suffix = counter.getAttribute('data-suffix');

        let startTimestamp = null;

        const step = (timestamp) => {
          if (!startTimestamp) startTimestamp = timestamp;
          const progress = Math.min((timestamp - startTimestamp) / duration, 1);

          const easeProgress = 1 - Math.pow(1 - progress, 2);
          const currentVal = Math.round(easeProgress * target);

          counter.innerText = currentVal.toLocaleString() + suffix;

          if (currentVal < target && progress < 1) {
            window.requestAnimationFrame(step);
          } else {
            counter.innerText = target.toLocaleString() + suffix;
          }
        };

        window.requestAnimationFrame(step);
        observer.unobserve(counter);
      }
    });
  };

  const observer = new IntersectionObserver(animateCounters, {
    root: null,
    threshold: 0.5
  });

  counters.forEach(counter => {
    observer.observe(counter);
  });
});
